import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import Learnables from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Learnables';
import Card from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/Card';
import { YoutubeScenario } from 'src/types/domain';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

const PALETTE = 'blue';

type CommunicateProps = {
  scenario: YoutubeScenario;
  ticketsLink: string;
};

const Communicate: FC<CommunicateProps> = ({ scenario: { learnables }, ticketsLink }) => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const cta = intl.formatMessage(msgs.cta);
  const learnablesLabel = intl.formatMessage(msgs.learnablesLabel);
  const text = intl.formatMessage(targetMsgs.text, {
    a: (chunk: ReactNode) => (
      <a href={ticketsLink} rel="noreferrer" target="_blank">
        {chunk}
      </a>
    ),
  });
  const title = intl.formatMessage(targetMsgs.title);
  const topic = intl.formatMessage(msgs.topic);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <Card $palette={PALETTE}>
      <S.Topic>{topic}</S.Topic>
      <S.Title>{title}</S.Title>
      <S.Text>{text}</S.Text>
      <S.MissionCard mode="vertical" mission="buying-a-cinema-ticket" />
      <S.LearnablesLabel>{learnablesLabel}</S.LearnablesLabel>
      <Learnables learnables={learnables} $palette={PALETTE} />

      <S.FixFlexBasis>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSizeBreakpoint="md"
          buttonType="primary"
          fullWidth="always"
          href={signUpHref}
        >
          {cta}
        </Button>
      </S.FixFlexBasis>
    </Card>
  );
};

export default Communicate;
